<div class="app-layout" [ngClass]="{'users-status-app': isUsersStatusPage}">
  <div class="layout-wrapper" [ngClass]="getClasses()">
    <app-navbar *ngIf="showNavigation"></app-navbar>
    <main class="main-layout" [ngClass]="{'auth-main': !showNavigation && !isUsersStatusPage, 'users-status-main': isUsersStatusPage}">
      <app-sidebar *ngIf="showNavigation"></app-sidebar>
      <div class="content-area" [ngClass]="{'auth-content': !showNavigation && !isUsersStatusPage, 'admin-content': isAdminPage, 'users-status-content': isUsersStatusPage}">
        <router-outlet></router-outlet>
      </div>
      <div class="overlay" (click)="toggleSidebar()" *ngIf="showNavigation"></div>
    </main>
  </div>
</div>